export const ACCOUNT_TYPE = {
  CHECKING: 'checking',
} as const;

export const SESSION_STORAGE_PAYMENT_DATA = 'checkoutPaymentData';

export const CHECKOUT_RESPONSE_DATA = {
  PAYMENT_SESSION_ID: 'cko-payment-session-id',
  SESSION_ID: 'cko-session-id',
  PAYMENT_ID: 'cko-payment-id',
};

export const PAYMENT_LINK_V2_QUERY_PARAMS = {
  BASE_AMOUNT: 'base-amount',
  FEATURE: 'feature',
  FAILURE: 'failure',
  PAYER_METADATA: 'payerMetadata',
  GROUP_ID: 'groupId',
  FROM_PARTICIPANT_ID: 'participantId',
  TO_PARTICIPANT_ID: 'toParticipantId',
  FUND_RAISE: 'fundraise',
} as const;

export const PAYMENT_LINK_V2_FEATURES = {
  SPLITS: 'splits',
  GROUPS: 'groups',
} as const;
